var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"display-2",attrs:{"id":"total-tags-scanned"}},[_vm._v("Total: "+_vm._s(_vm.total))])
}
var staticRenderFns = []

export { render, staticRenderFns }